import store from '@/store';
import router from './index';

const whiteList = []; // 권한 상태 상관 없는 페이지
const errPageReg = new RegExp('^/error/.*$');

router.beforeEach((to, from, next) => {
  const { name } = to;

  // 에러 페이지 계열이면 허용
  if (errPageReg.test(to.path) || whiteList.includes(name)) { // 화이트리스트 페이지일 경우 그냥 허용
    return next();
  }

  return store.dispatch('checkSSOState').then(() => {
    if (name === 'login' || name === 'empty') return next({ name: 'loginAfter' });
    return next();
  }).catch(() => {
    if (name !== 'login' || name === 'empty') return next({ name: 'login' });
    return next();
  });
});
